import React, { useContext } from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import { ActionIcon, Alert, Tooltip } from "@mantine/core";
import { BsFillCheckCircleFill } from "react-icons/bs";
import TrashIcon from "./NewCart/Icons/TrashIcon";
import { removeDiscount } from "../Actions/articleActions";
import { useDispatch } from "react-redux";
import {
  ADD_GIFT_CERTIFICATE,
  AppContext,
  CLEAR_PAYMENT_METHOD,
} from "../context";
import { removePayment } from "../Actions/paymentActions";

const DiscountAlert = ({
  sale,
  color,
  title,
  text,
  giftCard,
  tooltip,
  setShowRemovedText,
}) => {
  const rdxDispatch = useDispatch();
  const { dispatch } = useContext(AppContext);

  const icon =
    color === "green" ? (
      <BsFillCheckCircleFill />
    ) : (
      <AiFillCloseCircle className={"error-icon"} />
    );

  const styles =
    color === "green"
      ? {
          backgroundColor: "#d8fcd4",
          border: "1px solid #378d25",
          span: { color: "#32324D" },
        }
      : { backgroundColor: "#FCECEA", span: { color: "#32324D" } };

  const remove = () => {
    setShowRemovedText(true);

    if (giftCard) {
      const [getGiftCertificate] = sale.payments.filter(
        (el) => el.paymentMethodName === "Presentkort"
      );
      if (getGiftCertificate?.key) {
        rdxDispatch(removePayment(getGiftCertificate.key, true));
      }
      dispatch({
        type: CLEAR_PAYMENT_METHOD,
        payload: getGiftCertificate?.key,
      });
      dispatch({
        type: ADD_GIFT_CERTIFICATE,
        payload: null,
      });
    } else {
      rdxDispatch(removeDiscount(sale.id));
    }
    setTimeout(() => {
      setShowRemovedText(false);
    }, 1000);
  };

  return (
    <div>
      <Alert
        className={`alert${color}`}
        title={title}
        color={color}
        icon={icon}
        sx={styles}
        role="region"
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0.25rem",
          }}
        >
          {text}
          <Tooltip label={tooltip}>
            <ActionIcon
              color="default"
              className={`trashButton`}
              onClick={() => remove()}
              aria-label={tooltip}
            >
              <TrashIcon />
            </ActionIcon>
          </Tooltip>
        </div>
      </Alert>
    </div>
  );
};

export default DiscountAlert;
